import { useMemo } from 'react';
import { paths } from 'src/routes/paths';
import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify';
import { useAuthContext } from 'src/auth/hooks';

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: icon('ic_dashboard'),
};

const TELE_REG_NOS =
  process.env.REACT_APP_TELE_REG_NOS?.split(',').map(v => v.trim()) || [];

export function useNavData() {
  const { user } = useAuthContext();
  const userRegNo = user?.registration_number;

  const data = useMemo(() => {
    const items = [
      {
        subheader: 'Overview',
        items: [{ title: 'Dashboard', path: paths.doctor_dashboard.root, icon: ICONS.dashboard }],
      },
      {
        subheader: 'Settings',
        items: [
          {
            title: 'Doctor Profile',
            path: paths.doctor_dashboard.profile,
            icon: ICONS.dashboard,
          },
        ],
      },
    ];

    if (TELE_REG_NOS.includes(userRegNo)) {
      items.push({
        subheader: 'Tele Packages',
        items: [
          {
            title: 'User Responses',
            path: paths.doctor_dashboard.responses,
            icon: ICONS.dashboard,
          },
        ],
      });
    }

    return items;
  }, [userRegNo]);

  return data;
}

export function useBottomNavData() {
  const { user } = useAuthContext();
  const userRegNo = user?.registration_number;

  const data = useMemo(() => {
    const items = [
      { title: 'Home', path: paths.doctor_dashboard.root, icon: <Iconify icon="tabler:home" /> },
      {
        title: 'Bookings',
        path: paths.doctor_dashboard.root,
        icon: <Iconify icon="tabler:calendar-filled" />,
      },
      {
        title: 'Profile',
        path: paths.doctor_dashboard.profile,
        icon: <Iconify icon="tabler:user" />,
      },
    ];

    if (TELE_REG_NOS.includes(userRegNo)) {
      items.push({
        title: 'Responses',
        path: paths.doctor_dashboard.responses,
        icon: <Iconify icon="tabler:clipboard-list" />,
      });
    }

    return items;
  }, [userRegNo]);

  return data;
}
